// extracted by mini-css-extract-plugin
export default {"userTableHeader":"UserDetails_userTableHeader__wKfwn","userTableBody":"UserDetails_userTableBody__WR4By"};